export const DEFAULT_ERROR_MESSAGE =
  'Something went wrong, please try again later. If the issue persists please contact FundRE for support.';
